import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Index.css';

const Index = () => {
  const [deudas, setDeudas] = useState([]);
  const navigate = useNavigate();

  const fetchDeudas = async () => {
    try {
      const res = await axios.get('https://deudas.transpoortessolorzano.com/deudas');
      setDeudas(res.data);
    } catch (error) {
      console.error('Error al obtener deudas:', error);
    }
  };

  useEffect(() => {
    fetchDeudas();
  }, []);

  const verDetalles = (choferId) => {
    navigate(`/deudas/${choferId}`);
  };

  return (
    <div className="deudas-container">
      <h1 className="deudas-title">Resumen de Deudas por Chofer</h1>
      <table className="deudas-table">
        <thead>
          <tr>
            <th>Chofer</th>
            <th>Total Prestado</th>
            <th>Total Abonado</th>
            <th>Deuda Actual</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          {deudas.map((deuda) => (
            <tr key={deuda.chofer_id}>
              <td>{deuda.nombre}</td>
              <td>${parseFloat(deuda.total_prestado).toLocaleString('es-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
              <td>${parseFloat(deuda.total_abonado).toLocaleString('es-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
              <td className={deuda.deuda_actual > 0 ? 'deuda-negativa' : 'deuda-positiva'}>
                ${parseFloat(deuda.deuda_actual).toLocaleString('es-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </td>
              <td>
                <button className="ver-detalles-btn" onClick={() => verDetalles(deuda.chofer_id)}>
                  Ver
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Index;
